import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { postCompactado } from "../../../redux/actions";
import { useEffect, useState } from "react";
import SuccessModal from "../../../components/modals/successModal";
import ErrorModal from "../../../components/modals/errorModal";
import Button from "../../../components/button";

function CompactarComponent({
  idSecuestro,
  closeModalCompactar,
  nroActa,
  lugar,
  refreshDetalle,
}) {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.currentUserId);

  const {
    handleSubmit,
  } = useForm();

  const [fecha_hora, setFecha_hora] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorModal, setErrorModal] = useState({
    show: false,
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const openErrorModal = (message) =>
    setErrorModal({ show: true, message });

  const closeErrorModal = () =>
    setErrorModal({ show: false, message: "" });

  useEffect(() => {
    const obtenerFechaHoraArgentina = () => {
      const ahora = new Date();

      const opciones = {
        timeZone: "America/Argentina/Buenos_Aires",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      };

      const formatoArgentina = new Intl.DateTimeFormat(
        "es-AR",
        opciones
      ).format(ahora);

      return formatoArgentina
        .replace(/\//g, "-")
        .replace(",", "");
    };

    setFecha_hora(obtenerFechaHoraArgentina());
  }, []);

  const onSubmit = async () => {
    setLoading(true);

    const finalData = {
      fecha_hora,
      idSecuestro,
      userId,
      nroActa,
      lugar,
    };

    try {
      const response = await dispatch(postCompactado(finalData));

      if (response) {
        setShowSuccessModal(true);
      }
    } catch (error) {
      console.error(error);

      const serverErrorMessage =
        error.response?.data?.error ||
        "Error inesperado al registrar la compactación.";

      openErrorModal(serverErrorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSuccess = () => {
    setShowSuccessModal(false);

    if (typeof refreshDetalle === "function") {
      refreshDetalle();
    }

    closeModalCompactar();
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      onClick={closeModalCompactar}
    >
      {showSuccessModal && (
        <SuccessModal
          closeSuccessModal={handleCloseSuccess}
          message="Compactación registrada con éxito."
        />
      )}

      {errorModal.show && (
        <ErrorModal
          closeErrorModal={closeErrorModal}
          message={errorModal.message}
        />
      )}

      <div className="relative">
        <button
          type="button"
          onClick={closeModalCompactar}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
        >
          ✕
        </button>

        <form
          onSubmit={handleSubmit(onSubmit)}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="w-[20rem] bg-white p-6 rounded-lg shadow-lg">
            <div className="text-2xl font-bold mb-4 text-center">
              Compactar
            </div>

            <div className="mb-4">
              <label className="block text-m font-medium mb-2 text-center">
                ¿Confirma la compactación de este vehículo?
              </label>
            </div>

            <div className="block text-sm font-medium text-gray-700 mb-3">
              Fecha/hora: {fecha_hora}
            </div>

            <div className="flex flex-col justify-center gap-4">
              <Button type="submit" fullWidth loading={loading}>
                Confirmar
              </Button>

              <Button
                type="button"
                variant="secondary"
                fullWidth
                disabled={loading}
                onClick={closeModalCompactar}
              >
                Cancelar
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CompactarComponent;